module.exports = __webpack_public_path__ + "static/Siemens-logo.svg-c10985b80ba7e7e6cdea03ec81d19810.png";